import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Import from './icon-import.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Import {...validProps} />;
}
SvgComponent.iconName = 'iconImport';

/**
 * @deprecated This is a legacy icon
 */
export const ImportIcon = svgIconWrapper(SvgComponent);
